// extracted by mini-css-extract-plugin
module.exports = {"sub-page":"SubPageTitle_sub-page__DMpVh","active-cart-link":"SubPageTitle_active-cart-link__Lqin2","button-wrapper":"SubPageTitle_button-wrapper__piSWD"};